<template>
  <main>
    <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>
    <page-header-compact
      >Historia Clinica - {{ name_historia }}</page-header-compact
    >
    <br />
    <div class="container-xl px-4">
      <div class="card">
        <cardInformacionUsuario :usuario="usuario"></cardInformacionUsuario>
      </div>
      <br />
      <wizard
        :steps="steps.length"
        @prev="prev($event)"
        @next="next($event)"
        :current_step="current"
      >
        <template #tabs>
          <wizard-tab
            v-for="(component, i) in steps"
            :key="`tabs_${i}`"
            :title="component.title"
            :step="i + 1"
            :active="i + 1 === current"
            :id="`step${i + 1}`"
            v-on:tab-click="next({ prev: current, current: i + 1 })"
          >
          </wizard-tab>
        </template>
        <template #tab-content>
          <wizard-tab-pane id="step1" active="true">
            <template #content>
              <component
                :is="currentComponent.ref"
                :ref="currentComponent.ref"
                v-bind="currentProperties"
              ></component>
            </template>
          </wizard-tab-pane>
        </template>
        <template #finish>
          <div class="row">
            <remision-component
              :idHistoria="idHistoria"
              :usuario="usuario"
            ></remision-component>
            <incapacidad-component
              :idHistoria="idHistoria"
              :usuario="usuario"
            ></incapacidad-component>
            <finalizar-historia
              :id-usuario="usuario.id"
              :id-historia="idHistoria"
              :codigoHistoria="'NUTRICION'"
            ></finalizar-historia>
          </div>
        </template>
      </wizard>
    </div>
  </main>
</template>
<script>
import Wizard from "../../../components/common/utilities/Wizard/Wizard";
import WizardTab from "../../../components/common/utilities/Wizard/WizardTab";
import WizardTabPane from "../../../components/common/utilities/Wizard/WizardTabPane";
import motivoConsultaComponent from "../base/motivoConsulta/motivoConsulta";
import examenFisicoComponent from "../base/examenFisico/examenFisico";
import PageHeaderCompact from "../../../components/layouts/content/page-header-compact";
import historiaClinicaService from "../../../services/historiaClinicaService";
import ordenComponent from "../base/orden/ordenComponent";
import formulaMedicaComponent from "../base/formulaMedica/formulaMedicaComponent";
import impresionDXComponent from "../base/impresionDX/impresionDXComponent";
import modalInformacionUsuario from "../base/informacionUsuario/modalInformacionUsuario";
import cardInformacionUsuario from "../base/informacionUsuario/cardInformacionUsuario";
import situacionesPersonalesComponent from "../base/baseSituacionesPersonales/indexSituacionesPersonales";
import intervenciones from "@/views/historias/base/intervenciones/intervenciones";
import recomendaciones from "@/views/historias/base/recomendaciones/recomendaciones";
import revisionSistemas from "@/views/historias/base/baseUrgencia/revision";
import FinalizarHistoria from "@/views/historias/base/finalizarHistoria/finalizarHistoria";
import RemisionComponent from "../base/baseRemision/index";
import resumenHcComponent from "./resumenHcComponent";
import incapacidadComponent from "../base/baseIncapacidades/index";
import indexExamenes from "../base/baseReporteExamenesAdolescente/indexExamenes";
import dayjs from "dayjs";
import embarazoService from "../../../services/embarazoService";
import indexAnamnesisAlimentaria from "../base/baseAnamnesisAlimentaria/indexComponent.vue";
import frecuenciaAlimentaria from "./formulariosComponent.vue";
import menuGuiaAlimentacion from "@/views/historias/base/baseAnamnesisAlimentaria/menuGuiaComponent.vue";
import imcGraph from "../base/baseGraficasEmbarazo/imcGraph";
import graficasService from "../../../services/graficasService";
import graficasComponent from "../infancia/graficas.vue";
import educacionGrupal from "../base/baseRespuestaFormularios/index";
import indexVacunas from "@/views/historias/base/baseVacunas/index/indexVacunas";

export default {
  components: {
    FinalizarHistoria,
    PageHeaderCompact,
    motivoConsultaComponent,
    examenFisicoComponent,
    WizardTabPane,
    WizardTab,
    Wizard,
    ordenComponent,
    formulaMedicaComponent,
    impresionDXComponent,
    modalInformacionUsuario,
    cardInformacionUsuario,
    situacionesPersonalesComponent,
    intervenciones,
    recomendaciones,
    revisionSistemas,
    RemisionComponent,
    resumenHcComponent,
    incapacidadComponent,
    indexExamenes,
    indexAnamnesisAlimentaria,
    frecuenciaAlimentaria,
    menuGuiaAlimentacion,
    imcGraph,
    graficasComponent,
    educacionGrupal,
    indexVacunas,
  },
  data() {
    return {
      finalizada: "",
      idHistoria: "",
      idTipoHistoria: "",
      usuario: {},
      ultimoEmbarazo: {},
      current: 1,
      checkpoint: 1,
      name_historia: "",
      data_imc: [],
      observacionesGraphs: '',
      code_hc:'',
      dateHc:''
    };
  },
  methods: {
    prev(step) {
      this.current = step.current;
      this.activeTab();
    },
    async next(step) {
      if (step.prev <= this.checkpoint && step.current - 1 > step.prev) {
        this.activeTab();
        return;
      }

      const refComponent = this.steps[step.prev - 1].ref;

      if (typeof this.$refs[refComponent].save !== "undefined") {
        await this.$refs[refComponent].save();
      }

      if (this.steps[step.prev - 1].validate) {
        if (this.$refs[refComponent].$v.$invalid) return;
      }

      if (step.current > this.checkpoint) {
        historiaClinicaService.updateCheckpoint(this.idHistoria, step.current);
        this.checkpoint = step.current;
      }

      this.current = step.current;

      this.activeTab();
    },
    async cargar(id) {
      const response = await historiaClinicaService.show(id);
      this.usuario = response.data.usuario;
      this.finalizada = response.data.finalizada;
      this.name_historia = response.data.tipo_historia.nombre;
      //this.current = response.data.checkpoint;
      //this.checkpoint = response.data.checkpoint;

      this.idTipoHistoria = response.data.id_tipo_historia;
      this.code_hc=response.data.tipo_historia.codigo;
      this.dateHc=response.data.fecha;

      this.activeTab();

      this.ultimoEmbarazo = (
        await embarazoService.showByLast(this.usuario.id)
      )?.data;

      if (this.ultimoEmbarazo?.id) {
        try {
          this.data_imc = (await embarazoService.showPesoTalla(this.usuario.id))?.data ?? [];
        } catch {
          this.data_imc = [];
        }
      } else {
        this.data_imc = [];
      }

      try {
        this.observacionesGraphs = (await graficasService.show(this.idHistoria))?.data.find(chart => chart.code === 'eva_nut')?.observations;
      } catch {
        this.observacionesGraphs = '';
      }

      this.current = response.data.checkpoint;
      this.checkpoint = response.data.checkpoint;
    },
    activeTab() {
      document.querySelectorAll(`a.active`).forEach((a) => {
        a.classList.remove("active");
      });
      document
        .querySelector(`a[href='${this.steps[this.current - 1].stepId}']`)
        .classList.add("active");
    },
  },
  created() {
    this.idHistoria = this.$route.params.id;
    this.cargar(this.idHistoria);
  },
  computed: {
    currentProperties() {
      if (this.currentComponent.ref === "index") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
        };
      }

      if (this.currentComponent.ref === "motivoConsultaComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
        };
      }

      if (this.currentComponent.ref === "examenFisicoComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          modo: this.code_hc!=='NUTRICION'?'INFANCIA':'NUTRICION',
        };
      }

      if (this.currentComponent.ref === "situacionesPersonalesComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario,
          idUsuario: this.usuario.id,
        };
      }

      if (this.currentComponent.ref === "controlComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario,
        };
      }

      if (this.currentComponent.ref === "ordenComponent") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
          idTipoHistoria: this.idTipoHistoria,
        };
      }

      if (this.currentComponent.ref === "formulaMedicaComponent") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
        };
      }
      if (this.currentComponent.ref === "impresionDXComponent") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
        };
      }
      

      if (this.currentComponent.ref === "indexExamenes") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
          idUsuario: this.usuario.id,
          idTipoHistoria: this.idTipoHistoria,
        };
      }

      if (this.currentComponent.ref === "resumenHcComponent") {
        return {
          idHistoria: this.idHistoria,
          idUsuario: this.usuario.id,
        };
      }

      if (this.currentComponent.ref === "revisionSistemas") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          sexo: this.usuario.sexo,
        };
      }

      if (this.currentComponent.ref === "intervenciones") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario.sexo,
          idTipoHistoria: this.idTipoHistoria,
        };
      }

      if (this.currentComponent.ref === "recomendaciones") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario.sexo,
          idTipoHistoria: this.idTipoHistoria,
        };
      }

      if (this.currentComponent.ref === "indexAnamnesisAlimentaria") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario.sexo,
          idTipoHistoria: this.idTipoHistoria,
          idUsuario: this.usuario.id,
        };
      }

      if (this.currentComponent.ref === "menuGuiaAlimentacion") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario.sexo,
          idTipoHistoria: this.idTipoHistoria,
          idUsuario: this.usuario.id,
        };
      }

      if (this.currentComponent.ref === "frecuenciaAlimentaria") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          usuario: this.usuario.sexo,
          idTipoHistoria: this.idTipoHistoria,
          idUsuario: this.usuario.id,
          codigo:"FRCA"
        };
      }

      if (this.currentComponent.ref === "imcGraph") {
        return {
          idHistoria: this.idHistoria,
          idUsuario: this.usuario.id,
          data_imc: this.data_imc,
          x: 20,
          y: 23,
          observacionesGraphs: this.observacionesGraphs,
          
        };
      }

      if (this.currentComponent.ref === "graficasComponent") {
        return {
          idHistoria: this.idHistoria,
          usuario: this.usuario,
        };
      }

       if (this.currentComponent.ref === "educacionGrupal") {
        return {
          idHistoria: this.idHistoria,
          finalizada: this.finalizada,
          idUsuario: this.usuario.id,
          usuario: this.usuario,
          codigo: this.edad <= 1826 ? "EDUCACION_GP_INF" : "EDUCACION_G_INF",
        };
      }

      if (this.currentComponent.ref === "indexVacunas") {
        return {
          idHistoria: this.idHistoria,
          idUsuario: this.usuario.id,
          finalizada: this.finalizada,
        };
      }

      return {};
    },
    currentComponent() {
      return this.steps[this.current - 1];
    },
    steps() {
      let components = [
        {
          ref: "motivoConsultaComponent",
          title: "Motivo de Consulta",
          validate: true,
        },
        {
          ref: "examenFisicoComponent",
          title: "Examen Físico",
          validate: true,
        },
        /* {
          ref: "imcGraph",
          title: "IMC",
          validate: false,
        }, */
        {
          ref: "revisionSistemas",
          title: "Revision por Sistemas",
          validate: true,
        },
        { ref: "indexExamenes", title: "Reporte Examenes", validate: false },
        { ref: "indexAnamnesisAlimentaria", title: "Anamnesis Alimentaria", validate: true },
        { ref: "frecuenciaAlimentaria", title: "Frecuencia Alimentaria", validate: true },
        { ref: "impresionDXComponent", title: "Impresión DX", validate: true },
        ...(
          this.code_hc!=='NUTRICION' ? 
          [
            { ref: "graficasComponent", title: "Graficas", validate: false },
            { ref: "indexVacunas", title: "Vacunas", validate: false }
          ]: 
          [{ ref: "menuGuiaAlimentacion", title: "Menu Guia Alimentacion", validate: true }]
        ),
        { ref: "ordenComponent", title: "Ordenes", validate: false },
        { ref: "formulaMedicaComponent", title: "Formulas", validate: false },
        {
          ref: "intervenciones",
          title: "Plan de Intervención",
          validate: false,
        },
        { ref: "recomendaciones", title: "Recomendaciones", validate: false },
        ...(this.code_hc!=='NUTRICION' && (this.edad >= 0 && this.edad <= 4380) ? [{ ref: "educacionGrupal", title: "Educacion Grupal", validate: true }]:[]),
        { ref: "resumenHcComponent", title: "Resumen", validate: false },
      ];


      return components.map((x, i) => {
        return {
          stepId: `#step${i + 1}`,
          ...x,
        };
      });
    },
    edad: function () {
      const now = dayjs(this.dateHc);
      console.log(now.diff(this.usuario.fecha_nacimiento, "day"));
      console.log(now.diff(this.usuario.fecha_nacimiento, "year"));
      return now.diff(this.usuario.fecha_nacimiento, "day");
    },
  },
  watch: {
    current: {
      async handler(newStep) {
        const stepIndex = this.steps.findIndex(s => s.ref === 'imcGraph');
        if (stepIndex === -1 || newStep !== stepIndex + 1) return;

        if (this.ultimoEmbarazo?.id) {
          try {
            this.data_imc = (await embarazoService.showPesoTalla(this.usuario.id))?.data ?? [];
          } catch {
            this.data_imc = [];
          }
        } else {
          this.data_imc = [];
        }

        try {
          this.observacionesGraphs = (await graficasService.show(this.idHistoria))
            ?.data.find(chart => chart.code === 'eva_nut')?.observations;
        } catch {
          this.observacionesGraphs = '';
        }
      }
    }
  }
};
</script>
